/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

const barSelector = document.querySelector('.bar-selector');
const button = barSelector.querySelector('.bar-current-item');
const dropdown = barSelector.querySelector('.bar-dropdown');
const items = barSelector.querySelectorAll('[role="option"]');

const open = () => {
    button.setAttribute('aria-expanded', 'true');
    dropdown.removeAttribute('hidden');
};

const close = () => {
    button.setAttribute('aria-expanded', 'false');
    dropdown.setAttribute('hidden', '');
};

button.addEventListener('click', () => {
    button.getAttribute('aria-expanded') === 'true' ? close() : open();
});

document.addEventListener('click', (e) => {
    if (!barSelector.contains(e.target)) close();
});

document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
});

items.forEach(item => {
    item.addEventListener('click', () => {
        const chartKey = item.dataset.chartKey;
        const type = item.dataset.type;

        button.querySelector('.bar-current-label').textContent = item.textContent.trim();
        document.querySelector('.table-title-value').textContent = type;

        document.querySelectorAll('.measures-description').forEach(el => {
            el.toggleAttribute('hidden', el.dataset.chart !== chartKey);
        });

        document.querySelectorAll('[data-chart-table]').forEach(el => {
            el.toggleAttribute('hidden', el.dataset.chartTable !== chartKey);
        });

        close();
    });
});